import React, { useEffect } from 'react';
import {getFooter} from '../../services/layoutService';
const Footer = () => {
  useEffect(() => {
         getFooter('687PDC','EN');
  }, []);

  return <footer id="footer" className="ph-footer">  
  </footer>;
};

export default Footer;
